export const ProfileInfoFieldType = {
  BIC: 'bic',
  CURRENCY: 'currency',
  DATE: 'date',
  EMAIL: 'email',
  IBAN: 'iban',
  INPUT: 'input',
  PHONE: 'phone',
  SELECT: 'select',
  TEXT: 'text',
  TEXTAREA: 'textarea',
}

export const QA_NAME_PROFILE_INFO_COPY_BUTTON = 'profile_info_copy_button'

export const QA_NAME_PROFILE_INFO_EMAIL_BUTTON = 'profileInfoEmailButton'

export const QA_NAME_PROFILE_INFO_EXPAND_SECTIONS_BUTTON =
  'profile_info_expand_sections_button'

export const PROFILE_INFO_NOTES_FIELD_NAME = 'notes'

export const PROFILE_INFO_NOTES_MAX_LENGTH = 2000

export const PROFILE_INFO_NOTES_LABEL_KEY = 'Widget.InfoNotesLabelKey'

export const PROFILE_INFO_WIDGET_SKELETON_ROWS_COUNT = 5

export const PROFILE_INFO_MONEY_EMPTY_AMOUNT = '0.00'

export const PROFILE_INFO_MONEY_MAX_AMOUNT = 1000000000

export const PROFILE_INFO_COPYABLE_FIELD_TYPES = [
  ProfileInfoFieldType.EMAIL,
  ProfileInfoFieldType.PHONE,
]

export const PROFILE_INFO_COPY_RESET_TIMEOUT = 5000

export const PROFILE_INFO_COPY_TOOLTIP_KEY = {
  [ProfileInfoFieldType.EMAIL]: 'Widget.InfoCopyEmailTooltipKey',
  [ProfileInfoFieldType.PHONE]: 'Widget.InfoCopyPhoneTooltipKey',
  copied: 'Widget.InfoCopiedTooltipKey',
}

export const PROFILE_INFO_COPY_NOTIFICATION_KEY = {
  [ProfileInfoFieldType.EMAIL]: 'Notification.WidgetInfoEmailCopiedKey',
  [ProfileInfoFieldType.PHONE]: 'Notification.WidgetInfoPhoneCopiedKey',
}
